/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";
import {DateTimeWithTimezoneModel} from "@irian-ro/date-utils";

export class OfferItemViewVO extends JSONable {

  uuid: string | undefined = undefined;

  deliveryCountry: string | undefined = undefined;

  deliveryHandoverUuid: string | undefined = undefined;

  hasDeliveryIntervalOverlap: boolean | undefined = undefined

  hasPickupIntervalOverlap: boolean | undefined = undefined

  pickupCountry: string | undefined = undefined;

  pickupHandoverUuid: string | undefined = undefined;

  pickupCity: string | undefined = undefined;

  pickupTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  pickupTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  deliveryCity: string | undefined = undefined;

  deliveryTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  deliveryTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  requestedDeliveryTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  requestedDeliveryTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;

  requestedPickupTimeWindowStart: DateTimeWithTimezoneModel | undefined = undefined;

  requestedPickupTimeWindowEnd: DateTimeWithTimezoneModel | undefined = undefined;
}
